import { create } from "zustand";

interface CartStore {
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
  open: () => void;
  close: () => void;
}

export const useCart = create<CartStore>((set) => ({
  isOpen: false,
  setIsOpen: (open) => set({ isOpen: open }),
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
}));
